module.exports = __webpack_public_path__ + "img/authorizedSignature.c62addaa.svg";